/**
 * Apply an EndTurn: hand the turn over, then run the NEW current player's
 * turn-start refresh — refill AP, reset per-action caps, and clear their element
 * cooldown (rule.md §5, §7.3). Bastion is NOT refreshed — it is a once-per-game
 * save (rule.md §9), so it simply carries over until spent. Enforces the turn cap.
 */
import { AP_PER_TURN, TURN_CAP } from "../data/constants";
import type { EndTurnAction } from "../types/action";
import type { AugmentedWarState } from "../types/game-state";
import { opponentOf } from "../utils/state";
import { scoreTimeout } from "../utils/terminal";
import { updatePlayer } from "./shared";

export function applyEndTurn(
  state: AugmentedWarState,
  _action: EndTurnAction,
): AugmentedWarState {
  const nextPlayerId = opponentOf(state.currentPlayerId);
  const players = updatePlayer(state.players, nextPlayerId, {
    spentElements: [], // Bastion (bastionAvailable) carries over — once per game
  });

  const turn = state.turn + 1;
  const advanced: AugmentedWarState = {
    ...state,
    currentPlayerId: nextPlayerId,
    turn,
    apRemaining: AP_PER_TURN,
    actionsUsed: { move: 0, attack: 0, deploy: 0 },
    players,
  };

  if (turn > TURN_CAP) {
    return { ...advanced, phase: "GAME_END", result: scoreTimeout(advanced) };
  }
  return advanced;
}
